import { useState, useEffect } from "react";

const ModePaiementForm = ({ onSubmit, mode }) => {

  const [form, setForm] = useState({
    nom: ""
  });


  useEffect(() => {

    if (mode) {

      setForm({
        nom: mode.nom || ""
      });

    } else {

      setForm({
        nom: ""
      });

    }

  }, [mode]);



  const handleChange = (e) => {

    setForm({

      ...form,

      [e.target.name]: e.target.value

    });

  };



  const handleSubmit = (e) => {

    e.preventDefault();

    onSubmit(form);

  };



  return (

    <form
      className="client-form"
      onSubmit={handleSubmit}
    >

      <input

        type="text"

        name="nom"

        placeholder="Nom du mode de paiement"

        value={form.nom}

        onChange={handleChange}
        style={{ padding: "8px", width: "100%", marginBottom: "15px" }}

        required

      />


      <button type="submit">

        {mode ? "Modifier" : "Enregistrer"}

      </button>


    </form>

  );

};


export default ModePaiementForm;